// extracted by mini-css-extract-plugin
export var pillWrapper = "_ie-0";
export var showOverflow = "_ie-1";